<template>
    <div class="modal-content fm-modal-rename">
        <div class="modal-header">
            <h5 class="modal-title">{{ $t('filemanager.modal.rename.title') }}</h5>
            <button type="button" class="close" aria-label="Close" v-on:click="hideModal">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <label for="fm-input-rename">{{ $t('filemanager.modal.rename.fieldName') }}</label>
                <input type="text" class="form-control" id="fm-input-rename"
                       v-focus
                       v-bind:class="{'is-invalid': checkName}"
                       v-model="name"
                       v-on:keyup="validateName">
                <div class="invalid-feedback" v-show="checkName">
                    {{ $t('filemanager.modal.rename.fieldFeedback') }}
                    {{ directoryExist ? ` - ${$t('filemanager.modal.rename.directoryExist')}` : ''}}
                    {{ fileExist ? ` - ${$t('filemanager.modal.rename.fileExist')}` : ''}}
                </div>
                <small class="feedback" v-show="checkSpecialChar">
                    {{ $t('filemanager.modal.rename.checkChar') }}
                </small>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-info"
                    v-bind:disabled="submitDisable"
                    v-on:click="rename">{{ $t('filemanager.btn.submit') }}
            </button>
            <button class="btn btn-light" v-on:click="hideModal">{{ $t('filemanager.btn.cancel') }}</button>
        </div>
    </div>
</template>

<script>
import modal from '../mixins/modal';

export default {
  name: 'Rename',
  mixins: [modal],
  data() {
    return {
      name: '',
      isLoading: false,
      directoryExist: false,
      fileExist: false,
      old: ""
    };
  },
  computed: {
    /**
     * Selected item
     * @returns {*}
     */
    selectedItem() {
      return this.$store.getters[`${this.activeManager}/selectedList`][0];
    },

    /**
     * Check new name
     * @returns {boolean}
     */
    checkName() {
      return this.directoryExist || this.fileExist || !this.name;
    },

    /**
     * Submit button disable
     * @returns {*|boolean}
     */
    submitDisable() {
      return (this.old === this.name) ? true : this.checkName || this.name === this.selectedItem.basename || this.checkSpecialChar || this.isLoading;
    },
    checkSpecialChar() {
      var pattern = /[*'":\\|<>/?]/  
      let valid = false;
      if(pattern.test(this.name)) {
        valid = true;
      }
      return valid;
    },
  },
  watch: {
    name: function() {
      return this.submitDisable;
    }
  },
  mounted() {
    // initiate item name
    this.name = this.selectedItem.basename.split('.').splice(0, 1)[0];
    this.old = this.name;
  },
  methods: {
    /**
     * Validate item name
     */
    validateName() {
      if (this.name !== this.selectedItem.basename) {
        // if item - folder
        if (this.selectedItem.type === 'dir') {
          // check folder name matches
          this.directoryExist = this.$store.getters[`${this.activeManager}/directoryExist`](this.name);
        } else {
          // check file name matches
          this.fileExist = this.$store.getters[`${this.activeManager}/fileExist`](this.name);
        }
      }
    },

    /**
     * Rename item
     */
    rename() {
      this.isLoading = true;
      // create new name with path
      const newName = this.selectedItem.dirname
        ? `${this.selectedItem.dirname}/${this.name}`
        : this.name;

      this.$store.dispatch('rename', {
        type: this.selectedItem.type,
        newName,
        oldName: this.selectedItem.path,
      }).then(() => {
        this.isLoading = false;
        // close modal window
        this.hideModal();
      });
    },
  },
};
</script>

<style>
  .feedback {
    color: red;
  }
</style>
